import { compose } from 'common/formValidation/lib';
import { formValidate as fundingValidate } from './types/common/funding';
//* import bailleur privé ...
import privateRentalPropertyValidate from '../simulation/types/privateRental/Property/formValidate';
import privateRentalChargesValidate from '../simulation/types/privateRental/Charges/formValidate';
import privateRentalDetailsValidate from '../simulation/types/privateRental/Details/formValidate';
//* import pinel ...
import pinelPropertyValidate from '../simulation/types/pinel/Property/formValidate';
import pinelChargesValidate from '../simulation/types/pinel/Charges/formValidate';
import pinelDetailsValidate from '../simulation/types/pinel/Details/formValidate';
//* import pinelDenormandie ...
import denormandiePropertyValidate from '../simulation/types/pinelDenormandie/Property/formValidate';
import denormandieChargesValidate from '../simulation/types/pinelDenormandie/Charges/formValidate';
import denormandieDetailsValidate from '../simulation/types/pinelDenormandie/Details/formValidate';
//* import lmnp ...
import lmnpPropertyValidate from '../simulation/types/lmnp/Property/formValidate';
import lmnpChargesValidate from '../simulation/types/lmnp/Charges/formValidate';
import lmnpDetailsValidate from '../simulation/types/lmnp/Details/formValidate';
//* import scpi ...
import scpiValidate from '../simulation/types/scpi/Products/formValidate';
//* import dismemberedScpi ...
import dismemberedScpiValidate from '../simulation/types/dismemberedScpi/Products/formValidate';

//* import lifeInsurance ...
//* import per ...
const validationByProduct = {
    privateRental: compose({
        'simulation-property': privateRentalPropertyValidate,
        'simulation-funding': fundingValidate,
        'simulation-charges': privateRentalChargesValidate,
        'simulation-details': privateRentalDetailsValidate,
    }),

    pinel: compose({
        'simulation-property': pinelPropertyValidate,
        'simulation-funding': fundingValidate,
        'simulation-charges': pinelChargesValidate,
        'simulation-details': pinelDetailsValidate,
    }),

    pinelDenormandie: compose({
        'simulation-property': denormandiePropertyValidate,
        'simulation-funding': fundingValidate,
        'simulation-charges': denormandieChargesValidate,
        'simulation-details': denormandieDetailsValidate,
    }),

    lmnp: compose({
        'simulation-property': lmnpPropertyValidate,
        'simulation-funding': fundingValidate,
        'simulation-charges': lmnpChargesValidate,
        'simulation-details': lmnpDetailsValidate,
    }),

    scpi: scpiValidate,

    dismemberedScpi: dismemberedScpiValidate,

    // TODO: lifeInsurance
    // lifeInsurance: compose({ ... }),

    // TODO: per
    // per: compose({ ... }),
};

/**
 * Retourne la fonction de validation composite pour un produit donné,
 * ou null si le produit n'a pas de validation définie.
 *
 * @param {string} product - Le type de produit (ex: 'privateRental', 'pinel')
 * @returns {Function|null}
 */
const getValidationByProduct = (product) =>

    validationByProduct[product] || null;
export default getValidationByProduct;
